module.exports = __webpack_public_path__ + "img/1fab03e.svg";